var React = require('react');

function ActiveTab (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.5","y":"0.5","width":"15","height":"15","rx":"7.5","stroke":"#1BE3AD","key":0}),React.createElement("circle",{"cx":"5","cy":"5","r":"5","transform":"matrix(-1 0 0 1 13 3)","fill":"#1BE3AD","key":1})]);
}

ActiveTab.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ActiveTab;

ActiveTab.default = ActiveTab;
